<template>
  <div>
    <vue-headful :title="pageTitle"/>
    <v-layout>
      <h1><span>{{title}}</span></h1>
      <v-spacer></v-spacer>
      <v-btn color="primary" dark class="mr-0" :to="{name: 'AttestationIntro'}">{{ startBtnText }}</v-btn>
    </v-layout>
    <data-table :headers="headers" :items="items">
      <tr slot-scope="props" class="text-xs-center">
        <td>{{ props.index + 1 }}</td>
        <td>{{ props.item.test }} из 50</td>
        <td>{{ props.item.thematic}} из 30</td>
        <td>{{ props.item.practice }} из 40</td>
        <td>{{ total(props.item) }} из 120</td>
        <td>{{ props.item.status }}</td>
        <td>
          <v-btn flat icon :to="{name: 'AttestationResult', params: {id: props.item.id.toString()}}">
            <v-icon small>visibility</v-icon>
          </v-btn>
        </td>
      </tr>
    </data-table>
  </div>
</template>

<script>
import SettingsService from '@/services/SettingsService'
import DataTable from '@/components/fragments/DataTable'
import AttestationService from '@/services/AttestationService'

export default {
  components: {DataTable},
  data: () => ({
    title: 'Тренировки',
    isStarted: false,
    headers: [
      {text: '№', align: 'center', sortable: false, width: 50},
      {text: 'Тестирование', align: 'center', sortable: false},
      {text: 'Тематические', align: 'center', sortable: false},
      {text: 'Практические', align: 'center', sortable: false},
      {text: 'Итого', align: 'center', sortable: false},
      {text: 'Результат', align: 'center', sortable: false},
      {text: 'Действия', align: 'center', sortable: false, width: 156}
    ],
    items: [],
    attestationService: undefined
  }),
  computed: {
    pageTitle () {
      return SettingsService.pageTitle(this.title)
    },
    startBtnText () {
      return (this.isStarted ? 'Продолжить' : 'Начать').concat(' тренировку')
    }
  },
  methods: {
    total (item) {
      return item.test + item.thematic + item.practice
    }
  },
  created () {
    this.attestationService = new AttestationService(this.$store)
    this.attestationService.getTrainingResults((data) => {
      if (data.results) {
        data.results.forEach(info => {
          if (!this.isStarted && info && info.status === 'В процессе') {
            this.isStarted = true
          }
        })
        this.items = data.results
      }
    })
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/student/attestation/Index.vue